import classNames from "classnames";

export default function BigDataPage() {
  return <div className={classNames("pt-12 h-screen bg-white")}></div>;
}
